module.exports = __webpack_public_path__ + "media/superficial gastritis.63509966.wav";